import React from 'react'
import { sizes, socialIconColors } from './const'
export interface WeiboProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon including the cirlce.
     * */
    color?: 'white' | 'black'
}

export const WeiboIcon = ({
    className = 'js_WeiboIcon',
    size = 'large',
    color = 'black',
}: WeiboProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <circle
                    className={`${socialIconColors[color][0]}`}
                    cx={16}
                    cy={16}
                    r={15.5}
                />
                <path
                    className={`${socialIconColors[color][1]}`}
                    d="M14.558 19.54a.742.742 0 0 0 .098-.616.667.667 0 0 0-.401-.446.908.908 0 0 0-.652-.009.98.98 0 0 0-.535.41.743.743 0 0 0-.116.612.667.667 0 0 0 .383.45.867.867 0 0 0 .665.023 1.03 1.03 0 0 0 .558-.424zm.84-1.08a.27.27 0 0 0 .03-.236.254.254 0 0 0-.156-.166.357.357 0 0 0-.254.005.351.351 0 0 0-.192.165c-.101.184-.063.318.116.402a.37.37 0 0 0 .259-.005.35.35 0 0 0 .196-.165zm1.552.955c-.268.607-.738 1.053-1.41 1.339-.672.286-1.339.321-2 .107-.636-.202-1.075-.579-1.316-1.13-.24-.55-.222-1.107.058-1.673.28-.553.73-.967 1.352-1.24a2.818 2.818 0 0 1 1.88-.17c.66.173 1.131.528 1.414 1.067.283.538.29 1.105.022 1.7zm2.785-1.428c-.053-.571-.318-1.077-.794-1.517-.476-.44-1.097-.765-1.861-.973a6.79 6.79 0 0 0-2.45-.188c-1.327.137-2.427.558-3.298 1.263-.872.705-1.266 1.492-1.183 2.361.053.571.318 1.077.794 1.517.476.44 1.097.765 1.861.973a6.79 6.79 0 0 0 2.45.188c1.327-.137 2.427-.558 3.298-1.263.872-.705 1.266-1.492 1.183-2.361zm2.75.036c0 .404-.11.82-.331 1.245-.22.425-.545.833-.973 1.223-.428.39-.93.739-1.504 1.048-.574.31-1.247.557-2.017.741-.77.185-1.576.277-2.415.277s-1.657-.1-2.454-.3a8.714 8.714 0 0 1-2.147-.83 4.585 4.585 0 0 1-1.53-1.347 3.01 3.01 0 0 1-.58-1.78c0-.685.206-1.414.62-2.187.413-.774 1-1.542 1.762-2.303 1.006-1.006 2.022-1.708 3.049-2.107 1.026-.398 1.76-.378 2.2.063.387.38.446 1.002.178 1.865-.024.084-.026.143-.009.179a.111.111 0 0 0 .09.062.381.381 0 0 0 .13-.004c.044-.01.084-.02.12-.031l.053-.018c.827-.351 1.56-.527 2.196-.527.637 0 1.092.182 1.365.545.268.374.268.904 0 1.588a1.02 1.02 0 0 1-.04.179c-.015.041-.001.079.04.111a.463.463 0 0 0 .108.067c.03.012.08.03.151.054.34.107.646.247.92.42.273.172.511.414.714.727.202.312.303.659.303 1.04zm-.661-5.57c.25.28.412.603.486.968.074.366.055.716-.058 1.05a.52.52 0 0 1-.263.303.513.513 0 0 1-.7-.228.513.513 0 0 1-.037-.397c.12-.375.048-.705-.214-.99a.957.957 0 0 0-.955-.313.531.531 0 0 1-.401-.072.462.462 0 0 1-.224-.33.518.518 0 0 1 .072-.397.495.495 0 0 1 .33-.228 2.045 2.045 0 0 1 1.964.634zm1.615-1.455a4.118 4.118 0 0 1 1.004 1.986 4.086 4.086 0 0 1-.12 2.156.602.602 0 0 1-.304.357.574.574 0 0 1-.464.035.602.602 0 0 1-.357-.303.6.6 0 0 1-.044-.464c.166-.488.196-1 .089-1.535a2.9 2.9 0 0 0-.714-1.41 2.896 2.896 0 0 0-1.321-.853 3.059 3.059 0 0 0-1.544-.076.595.595 0 0 1-.464-.085.593.593 0 0 1-.268-.388.582.582 0 0 1 .085-.46.597.597 0 0 1 .388-.263 4.263 4.263 0 0 1 2.178.103c.72.223 1.339.623 1.856 1.2z"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
